import { IconButton, Layout, LuIcon } from "@overmap-ai/blocks"
import { type ComponentPropsWithRef, memo } from "react"

import { SLIDE_OUT_IDS } from "../../layouts"
import { modelIconMapping } from "../../mappings/icons"

type RightSlideOutButtonProps = Omit<ComponentPropsWithRef<typeof IconButton>, "children">

export const RightSlideOutButton = memo<RightSlideOutButtonProps>((props) => {
	return (
		<Layout.SlideOutTrigger slideOutId={SLIDE_OUT_IDS.RIGHT}>
			<IconButton {...props}>
				<LuIcon icon={modelIconMapping.rightPanel} />
			</IconButton>
		</Layout.SlideOutTrigger>
	)
})
RightSlideOutButton.displayName = "RightSlideOutButton"
